import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { RicosContext } from 'ricos-context';
import { FocusManager, ModalCloseButton, SettingsMobileHeader } from 'wix-rich-content-ui-components';
import { L as LINK_PANEL_MODAL } from '../../dataHooks-8eb1301a.js';
import { s as styles } from '../../link-panel-24293ab3.js';
import LinkActionsButtons from './LinkActionsButtons.js';
import LinkPanelWrapper from './LinkPanelWrapper.js';
import '../../style-inject.es-746bb8ed.js';
import 'lodash';
import 'wix-rich-content-common';
import './LinkPanel.js';
import 'wix-rich-content-common/libs/Tooltip';
import './AdvancedCheckboxes.js';
import './consts.js';
import './LinkPanelDropdown.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BasicLinkPanel extends PureComponent {
  render() {
    const {
      ariaProps,
      showNewTabCheckbox,
      showNoFollowCheckbox,
      showSponsoredCheckbox,
      showNoReferrerCheckbox,
      sharedPanelsProps,
      buttonsProps,
      linkPanelValues,
      onChangeLinkPanel,
      isMobile,
      hasCheckboxes = true,
      t,
      showCloseButton
    } = this.props;
    const { onCancel } = buttonsProps;
    const linkPanelContainerClassName = classNames(styles.basic_linkPanel_container, {
      [styles.basic_linkPanel_container_isMobile]: isMobile,
      [styles.basicPanel]: !hasCheckboxes
    });
    const showSeparator = hasCheckboxes && !isMobile;
    const renderActionButtons = () => isMobile ? /* @__PURE__ */ React.createElement(SettingsMobileHeader, __spreadProps(__spreadValues({}, buttonsProps), { title: t("MobileLinkModal_Title") })) : /* @__PURE__ */ React.createElement(LinkActionsButtons, __spreadProps(__spreadValues({ basicLinkPanel: true }, buttonsProps), { basicDisplay: !hasCheckboxes }));
    return /* @__PURE__ */ React.createElement(
      FocusManager,
      __spreadValues({
        className: linkPanelContainerClassName,
        "data-hook": LINK_PANEL_MODAL,
        jsdomMode: this.context.jsdomMode,
        role: "form"
      }, ariaProps),
      showCloseButton && /* @__PURE__ */ React.createElement("div", { className: styles.basic_linkPanel_header }, /* @__PURE__ */ React.createElement("div", null, t("Link_BasicModal_Header_Title")), /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal: onCancel })),
      /* @__PURE__ */ React.createElement("div", { className: styles.linkPanel_wrapper }, /* @__PURE__ */ React.createElement(
        LinkPanelWrapper,
        __spreadValues({
          linkValues: linkPanelValues,
          onChange: onChangeLinkPanel,
          showNewTabCheckbox,
          showNoFollowCheckbox,
          showSponsoredCheckbox,
          showNoReferrerCheckbox,
          hasCheckboxes
        }, sharedPanelsProps)
      )),
      showSeparator && /* @__PURE__ */ React.createElement("div", { className: styles.linkPanel_actionsDivider, role: "separator" }),
      renderActionButtons()
    );
  }
}
__publicField(BasicLinkPanel, "contextType", RicosContext);
BasicLinkPanel.propTypes = {
  t: PropTypes.func,
  ariaProps: PropTypes.object,
  showNewTabCheckbox: PropTypes.bool,
  showNoFollowCheckbox: PropTypes.bool,
  showSponsoredCheckbox: PropTypes.bool,
  showNoReferrerCheckbox: PropTypes.bool,
  sharedPanelsProps: PropTypes.object,
  buttonsProps: PropTypes.object,
  changeRadioGroup: PropTypes.func,
  linkPanelValues: PropTypes.object,
  onChangeLinkPanel: PropTypes.func,
  isMobile: PropTypes.bool,
  hasCheckboxes: PropTypes.bool,
  showCloseButton: PropTypes.bool
};

export { BasicLinkPanel as default };
//# sourceMappingURL=BasicLinkPanel.js.map
